import React, { useEffect, useState, useContext } from "react";
import Button from "../../components/common_components/Button";
import PlaceholderCardLayout from "../../components/layout_components/PlaceholderCardLayout";
import PayoutIcon from "../../../../../../assets/images/user_app/payouts_icon.svg";

function NoPayoutsCard({ balance, setShowRequestPayout, navigate }) {
    const title = balance > 0.0 ? `You have a balance of $${balance}!` : "Your payouts will show here"
    const subtitle = balance > 0.0 ? "You can request a payout now or earn more by completing additional missions." : "Once you have completed a mission, you'll be able to request a payout."

    const button = balance > 0.0 ?
        <Button size="large" color="primary" fullWidth={true} onClick={() => {
            setShowRequestPayout(true)
        }}>
            Request payout
        </Button>
        :
        <Button size="large" color="primary" fullWidth={true} onClick={() => {
            navigate("/missions")
        }}>
            Explore missions
        </Button>

    return (
        <PlaceholderCardLayout>
            <img src={PayoutIcon} className="payout-icon" alt="Payout" />
            <div className="placeholder-card-text-content-container">
                <h1 className="centered-h1-card-text">{title}</h1>
                <div className="centered-text body-medium grey-400-text">
                    {subtitle}
                </div>
            </div>
            <div className="full-width-button-container">
                {button}
            </div>
        </PlaceholderCardLayout>
    )
}

export default NoPayoutsCard